import classNames from 'classnames';

import './AICard.scss';

export const OnboardingPaywallAICard: React.FC<{
  title: string;
  subtitle: string;
  imageSrc: string;
  className?: string;
}> = ({ title, subtitle, imageSrc, className }) => {
  return (
    <div className={classNames('ai-card', className)}>
      <img src={imageSrc} alt="AI" />
      <div className="title">{title}</div>
      <div className="subtitle">{subtitle}</div>
    </div>
  );
};
